<template>
  <div id="app">
    <header class="header hamburger-menu">
      <sidebar-menu :menu="menu" :collapsed="true" @item-click="onItemClick" :disableHover="true">
        <span slot="toggle-icon" style="margin-left: -5px;"><i class="fa fa-arrows-h"></i></span>
        <span slot="dropdown-icon"><i class="fa fa-arrow-right"></i></span>
      </sidebar-menu>
    </header>

    <main class="main-container" v-on:click="toggleMenu()">
      <router-view></router-view>
    </main>

    <footer id="footer">
      <div class="inner">
        <div class="content">
          <section>
            <h3>SIG & Associates</h3>
            <p>Proudly serving Wichita Falls, TX, Haslet, TX, Decatur, TX, Prosper, TX, Vernon, TX, Garland, TX, and
              surrounding areas. Licensed in Texas, Oklahoma and Virginia.</p>

            <p>Please note that completion of the following requests for information does not constitute the purchase of
              insurance. No coverage may be added, changed or bound as a result of submitting this request for
              information or quotation of insurance. </p>

            <p>All coverage must be confirmed by the agency in writing subject to
              an acceptable signed application meeting the underwriting guidelines of the Insurance Company.
              SIG Insurance Services is licensed in the state of Texas. No solicitation of insurance is being made
              outside of this state.</p>
          </section>
          <section>
            <h4>Contact Us</h4>
            <ul class="plain">
              <li>
                <a href="tel:940-264-7515">
                  <span><i class="icon fa-phone">&nbsp;</i>James Cox: 940-264-7515</span>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/sigassociatesllc/" target="_blank">
                  <i class="icon fa-facebook">&nbsp;</i>Facebook</a>
              </li>
              <li>
                <a href="https://twitter.com/SIG_Associates" target="_blank">
                  <i class="icon fa-twitter">&nbsp;</i>Twitter</a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/sig-associates-b02b9a16b/" target="_blank">
                  <i class="icon fa-linkedin">&nbsp;</i>Linked In</a>
              </li>
              <li class="no-wrap">             
                <a href="https://goo.gl/maps/Zp9dEx3aUFWeov6p9" target="_blank">
                  <i class="icon fa-envelope">&nbsp;</i>813 8th St. Suite 550C, Wichita Falls, TX 76301</a>
              </li>
            </ul>
          </section>
        </div>
        <div class="copyright">
          Copyright © 2020 SIG & Associates
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import './assets/css/main.css'

Vue.use(VueSidebarMenu)

export default {
  name: 'app',
  data: function () {
    return {
      showProductList: false,
      menu: [
        {
          header: true,
          title: 'SIG Insurance',
          hiddenOnCollapse: true
        },
        {
          href: '/',
          title: 'Home',
          icon: 'fa fa-home'
        },
        {
          href: '/contact-us.html',
          title: 'Contact Us',
          icon: 'fa fa-mobile'
        },
        {
          title: 'Our Products',
          icon: 'fa fa-shopping-bag ',
          child: [
            {
              href: '/auto.html',
              title: 'Auto Insurance'
            },
            {
              href: '/home-insurance.html',
              title: 'Home Insurance'
            },
            {
              href: '/personal.html',
              title: 'Other Personal Insurance'
            },
            {
              href: '/life.html',
              title: 'Life Insurance'
            },
            {
              href: '/health.html',
              title: 'Health Insurance'
            },
            {
              href: '/rv.html',
              title: 'RV Insurance'
            },
            {
              href: '/financial.html',
              title: 'Financial Services'
            },
            {
              href: '/additional-insurance.html',
              title: 'Additional Insurance Services'
            },
            {
              href: '/specific-industries.html',
              title: 'Specific Industry Insurance'
            },
            {
              href: '/business.html',
              title: 'Commercial Coverage'
            },
            {
              href: '/employees.html',
              title: 'Employees Coverage'
            },
            {
              href: '/farm.html',
              title: 'Farm Insurance'
            }
          ]
        },
        {
          href: '/providers.html',
          title: 'Our Providers',
          icon: 'fa fa-handshake-o'
        }
      ]
    }
  },
  methods: {
    onItemClick: function () {
      window.scrollTo(0, 0)
    },
    navigateTo: function (path) {
      window.scrollTo(0, 0)

      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path)
        this.toggleMenu()
      }
    },
    showProducts: function () {
      this.showProductList = !this.showProductList
      document.querySelector('.product-list').style.display = 'none'

      if (this.showProductList) {
        document.querySelector('.product-list').style.display = 'block'
        document.querySelector('.product-list').style.top = document.querySelector('.full-menu').getBoundingClientRect().height + 'px'
      }
    },
    toggleMenu: function () {
      this.showProductList = false
      document.querySelector('.product-list').style.display = 'none'
    }
  }
}
</script>

<style scoped>
.menu-icon {
  font-size: 30px;
}

.left-icon {
  margin-right: 10px;
}

.right-icon {
  margin-left: 10px;
}

.header.hamburger-menu {
  display: flex;
}

.main-container,
#footer {
  margin-left: 60px;
}

.header.full-menu {
  display: none;
}

.product-list ul {
  columns: 3;
  color: #01500d;
  list-style-type: none;
}

.product-list ul li {
  border-bottom: 1px solid #E9E9E9;
}

.product-list ul li a {
  text-decoration: none;
}

.product-list ul li a:hover {
  text-decoration: underline;
}

.product-list ul li:before {
  margin-right: 10px;
  font: normal normal normal 20px/1 FontAwesome;
}

.product-list {
  position: absolute;
  background-color: #FFFFFF;
  padding: 20px;
  border: 3px solid #01500d;
  border-top: none;
  left: 50%;
  transform: translateX(-50%);
  display: none;
}

.title {
  font-size: 20px;
}

.knobs {
  background-color: #01500d;
}

.knob {
  font-size: 16px;
}

.header button {
  background-color: #01500d;
  box-shadow: inset 0 0 0 1px #01500d;
  color: #FFFFFF;
}

.header button:hover {
  background-color: #2a2a2e;
  box-shadow: inset 0 0 0 1px #2a2a2e;
  color: #FFFFFF;
}

.fixed-width {
  width: 220px
}

.no-wrap {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue